//Libraries
import _ from 'lodash'
import moment from 'moment'
import axios from 'axios'
import config from '../../../../variables/config'

//Functions and Data
import React, { useState, useEffect } from 'react'

export default ({ bookings }) => {
  const [toggleArray, setToggleArray] = useState([])
  const [editOn, setEditOn] = useState(false)
  const [classDate1, setClassDate1] = useState('')
  const [classDate2, setClassDate2] = useState('')
  const [classTime, setClassTime] = useState('')
  const [selectedBooking, setSelectedBooking] = useState({})
  const changeText = 'Edit'
  const submitText = 'Save'

  useEffect(() => {
    setToggleArray(Array(bookings.length).fill(false))
  }, [bookings])

  const format = 'DD MMM YYYY'

  const toggleExpand = i => {
    var temp = _.clone(toggleArray)
    temp[i] = !temp[i]

    setToggleArray(temp)
  }

  const getDate = booking => {
    if (booking.classDates && booking.classDates.length > 1) {
      const l = booking.classDates.length
      const dateOne =
        booking.classDates[0].classTime +
        ' ' +
        moment(booking.classDates[0].classDate).format(format)
      const dateTwo =
        booking.classDates[l - 1].classTime +
        ' ' +
        moment(booking.classDates[l - 1].classDate).format(format)

      return editOn && booking.id === selectedBooking.id
        ? (
            <input
              value={classDate1}
              onChange={e => setClassDate1(e.target.value)}
            />
          ) +
            'to' +
            (
              <input
                value={classDate2}
                onChange={e => setClassDate2(e.target.value)}
              />
            )
        : dateOne + ' to ' + dateTwo
    } else if (booking.classDates) {
      return (
        booking.classDates[0].classTime +
        ' ' +
        moment(booking.classDates[0].classDate).format(format)
      )
    } else {
      return editOn && booking.id === selectedBooking.id ? (
        <div>
          <input
            value={classTime}
            onChange={e => setClassTime(e.target.value)}
          />{' '}
          <input
            value={classDate1}
            onChange={e => setClassDate1(e.target.value)}
          />
        </div>
      ) : (
        booking.classTime + ' ' + moment(booking.classDate).format(format)
      )
    }
  }

  const getPrice = price => {
    return '£' + Math.round(price) / 100
  }

  const change = booking => {
    setEditOn(true)
    setClassTime(booking.classTime)
    setClassDate1(booking.classDate)
    setSelectedBooking(booking)
  }

  const submit = async booking => {
    let token = JSON.parse(window.localStorage.getItem('userData')).token
    let response = {}
    let newBooking = { ...booking }

    newBooking.classDate = classDate1
    newBooking.classTime = classTime
    try {
      response = await axios.patch(
        config.serverURL +
          '/ClassBooking' +
          config.endpoint +
          '/' +
          booking.id +
          '?access_token=' +
          token,
        newBooking
      )
      setEditOn(false)
    } catch (err) {
      if (response.data.status === 'success') {
        console.log('response ok')
      } else {
        throw new Error('Please fill all fields')
      }
    }
  }

  const removeClass = async booking => {
    if (
      window.confirm(
        'Are you sure you want to delete this booking? The action is permanant deletion and data is irrecoverable. Press CANCEL if unsure.'
      )
    ) {
      if (
        window.confirm(
          'Press OK to delete this booking. Please make sure your manager is informed. Any deletion without manager approval will be seriously breaching the portal user rule'
        )
      ) {
        let token = JSON.parse(window.localStorage.getItem('userData')).token
        let response = []
        try {
          response = await axios.delete(
            config.serverURL +
              '/ClassBooking' +
              config.endpoint +
              '/' +
              booking.id +
              '?access_token=' +
              token
          )
          window.alert('Booking Deleted')
        } catch (err) {
          if (response.data.status === 'success') {
            console.log('response ok')
          } else {
            throw new Error(response.data.error)
          }
        }
      }
    }
  }

  return bookings.map((booking, i) => (
    <div className="listItem" key={i}>
      <div className="itemRow">
        <div className="itemTitle" onClick={() => toggleExpand(i)}>
          {booking.className +
            ' - ' +
            (booking.user
              ? booking.user.firstName + ' ' + booking.user.lastName
              : 'No Name')}
        </div>
        <div className="itemTitle">
          {getPrice(booking.discountDetails.discountedTotal)}
        </div>
        <div className="bookingButtons">
          <div className="buttonWrapper" onClick={() => removeClass(booking)}>
            {'Delete'}
          </div>
          <div
            className="buttonWrapper"
            onClick={() => (editOn ? submit(booking) : change(booking))}>
            {editOn ? submitText : changeText}
          </div>
        </div>
      </div>
      <div className="itemRow">
        <div className="itemSubTitle">{getDate(booking)}</div>
      </div>
      {toggleArray[i] && (
        <div className="extraInfo">
          <div className="listItemName">
            {booking.user
              ? booking.user.firstName +
                ' ' +
                booking.user.lastName +
                ' - ' +
                booking.user.email +
                ' - ' +
                booking.user.phoneNumber
              : ''}
          </div>
          {booking.tickets.map((ticket, j) => {
            return (
              <div className="itemRow" key={j}>
                <div className="listItemTicket">
                  {ticket.quantity + 'x ' + ticket.name}
                </div>
                <div className="listItemTicket">
                  {getPrice(ticket.singleTicketPrice)}
                </div>
              </div>
            )
          })}
          <div className="listItemNote">{booking.note}</div>
          <div className="listItemReference">
            {booking.reference + ' ' + moment(booking.orderDate).format(format)}
          </div>
        </div>
      )}
    </div>
  ))
}
